import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TeacherAbsenceForm } from '../forms/TeacherAbsenceForm';

type TeacherAbsenceModalProps = {
  selectedAbsenceUuid?: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const TeacherAbsenceModal = ({ selectedAbsenceUuid, isOpen, onClose }: TeacherAbsenceModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={loading}
      title={selectedAbsenceUuid ? t('absences.edit') : t('absences.add')}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <TeacherAbsenceForm selectedAbsenceUuid={selectedAbsenceUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
